module.exports = __webpack_public_path__ + "static/media/pacRoyale-login.242ec022.png";